'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { useMedalliaFeedback } from '@libs/common-next';
import { FeedbackSkeleton } from './feedback-skeleton';
import './feedback-button.scss';
const TEXT = {
  error: 'Feedback is unavailable right now. Please try again later.',
  default: 'Help us improve your PetSmart experience.'
};
export function FeedbackButton() {
  const $ = _c(12);
  const {
    formState,
    onOpen
  } = useMedalliaFeedback();
  if (formState === "blocked") {
    return null;
  }
  if (formState === "loading") {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <FeedbackSkeleton />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const t0 = formState === "error";
  let t1;
  if ($[1] !== t0) {
    t1 = cn("feedback-button", {
      "feedback-button--error": t0
    });
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = formState === "error" ? TEXT.error : TEXT.default;
  let t3;
  if ($[3] !== t2) {
    t3 = <TextPassage className="feedback-button__text" size="lg">{t2}</TextPassage>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = formState === "error";
  let t5;
  if ($[5] !== onOpen || $[6] !== t4) {
    t5 = <Button text="Give feedback" disabled={t4} onClick={onOpen} />;
    $[5] = onOpen;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t5) {
    t6 = <div className={t1}>{t3}{t5}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}